var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useRef } from "react";
import QRCodeComp from "react-qr-code";
import { useMeasure } from "react-use";
import CopyImageService from "../../Services/Shared/CopyImageService.service";
const useQRCode = ({ url, qrCodeSize, level = "L", }) => {
    const svgRef = useRef(null);
    const [sizeRef, { width }] = useMeasure();
    const QRCode = React.useMemo(() => (_jsx("div", { className: "w-100", ref: sizeRef, children: _jsx(QRCodeComp, { id: "qr", size: qrCodeSize !== null && qrCodeSize !== void 0 ? qrCodeSize : width, value: url, level: level, 
            // @ts-expect-error can't figure out the ref type for this library, and it doesn't really matter.  This gives us a ref to the SVG.
            ref: svgRef }) })), [level, qrCodeSize, sizeRef, url, width]);
    const downloadQRCode = useCallback(() => {
        if (svgRef.current) {
            const svg = svgRef.current;
            const svgRect = svg.getBoundingClientRect();
            const canvas = document.createElement("canvas");
            canvas.width = svgRect.width;
            canvas.height = svgRect.height;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            const dataUri = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            img.onload = () => {
                if (ctx) {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    const image = canvas.toDataURL("image/png");
                    const link = document.createElement("a");
                    link.href = image;
                    link.download = "qrcode.png";
                    link.dispatchEvent(new MouseEvent("click"));
                }
            };
            img.src =
                "data:image/svg+xml;charset=utf-8," + encodeURIComponent(dataUri);
        }
    }, []);
    const copyQRCodeToClipboard = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!CopyImageService.isSupported()) {
            throw new Error("Copy to clipboard is not supported on this browser");
        }
        if (!svgRef.current) {
            throw new Error("No SVG reference");
        }
        const svg = svgRef.current;
        const svgRect = svg.getBoundingClientRect();
        const canvas = document.createElement("canvas");
        canvas.width = svgRect.width;
        canvas.height = svgRect.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            throw new Error("Could not get canvas context");
        }
        const DOMURL = window.URL || window.webkitURL || window;
        const img = new Image();
        const svgBlob = new Blob([new XMLSerializer().serializeToString(svg)], {
            type: "image/svg+xml;charset=utf-8",
        });
        const svgBlobUrl = DOMURL.createObjectURL(svgBlob);
        return new Promise((resolve, reject) => {
            img.onload = () => {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                canvas.toBlob((blob) => {
                    if (blob) {
                        CopyImageService.copyImage(blob).then(resolve, reject);
                        DOMURL.revokeObjectURL(svgBlobUrl);
                    }
                }, "image/png");
            };
            img.src = svgBlobUrl;
        });
    }), []);
    return React.useMemo(() => ({
        downloadQRCode,
        copyQRCodeToClipboard,
        QRCode,
        isCopySupported: CopyImageService.isSupported(),
    }), [QRCode, copyQRCodeToClipboard, downloadQRCode]);
};
export default useQRCode;
